import {Link} from "preact-router/match";

declare var STATIC_BASE_URL:string;
declare var BASE_URL:string;

import '../styles/forbes.scss';

import { h, Component } from 'preact';

export default class Forbes extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction"><a href="mailto:info@forbesaisolutions.com?subject=forbes insight" class="butt huge">Request a demo</a><Link class="butt huge" activeClassName="sel" href={ BASE_URL + 'forbes-insights/research' }>Research</Link><a href="https://www.querlo.com/forbes-insights-leadgen" class="butt huge">AI Free Customer Assistant</a></p>;

        return <div id="forbes" class="forbes">
          <div class="mainWrp">
            <section class="center">
              <div class="logoWrp">
                <img alt="Forbes Insights" class="logo" src={ STATIC_BASE_URL + 'images/public/forbes-insight_big@2x.png' } />
                <div>AI solutions powered by Querlo</div>
              </div>
              <h1>Content <span class="changecol">+</span> Conversation = <span class="changecol">Conversion</span></h1>
              <h2><span class="changecol">ENGAGE</span> | LEAD GENERATION</h2>
              <figure class="imgHolder">
                <img alt="Omnichannel by Querlo" src={ STATIC_BASE_URL + 'images/public/omnichannel.png' } />
              </figure>
              { calltoaction }
          </section>
          </div>
          <section class="full">
            <h2>
              Interactive engagement and intelligence gathering
            </h2>
            <p>
              To support your campaign, Forbes Insights will develop a conversational AI solution to engage the audience with the program content.
            </p>
            <iframe id="forbesChat" frameBorder="0" src="https://www.querlo.com/chat/forbesinsights"></iframe>
          </section>
          <div class="mainWrp">
            <section class="center cols">
              <div class="col">
                <div class="col">
                  <h3><img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_usecases.png' } /> Use Cases</h3>
                  <ul>
                    <li>Interactive Polls/ Self-Assessments</li>
                    <li>Persona building/ Audience Intelligence</li>
                    <li>Lead generation</li>
                    <li>Concierge/Commerce</li>
                    <li>Site/Experience Navigator</li>
                  </ul>
                </div>
                <div class="col">
                  <h3><img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_benefits.png' } /> Benefits</h3>
                  <ul>
                    <li>Increase conversion​</li>
                    <li>Understand behavior​</li>
                    <li>Spark conversations</li>
                    <li>Automate lead qualification</li>
                    <li>Lower lead processing costs</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_features.png' } /> Features</h3>
                  <ul>
                    <li>100% Cloud Based​</li>
                    <li>Natural Language Understanding​</li>
                    <li>Calendar booking</li>
                    <li>Connects with all CRMs​</li>
                  </ul>
                </div>
                <div class="col">
                  <h3><img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_mediatype.png' } /> Media Type</h3>
                  <ul>
                    <li>In-Banner</li>
                    <li>Social / Mobile</li>
                    <li>Landing Page</li>
                  </ul>
                </div>
              </div>
              
            </section>
          </div>
          <section class="full grey">
            { calltoaction }
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Forbes.tsx